import qs from 'qs'
import { TGetJournalsDataProps, TResJournals } from '../types'
import { parseGeneralSlug } from '~shared/utils/parseGeneralSlug'
import { fetcher } from '~shared/api/fetcher'
import { PATHS } from '~shared/constants/paths'

export const fetchJournals = async ({
  context,
  amount,
  start,
  filterBy
}: TGetJournalsDataProps) => {
  const { currentJournalsByFilterSlug } = parseGeneralSlug(
    context?.params?.general?.toString() || null
  )

  const activeSlug =
    filterBy ?? context?.params?.tag?.toString() ?? currentJournalsByFilterSlug
  try {
    const query = qs.stringify({
      sort: ['createdDate:desc'],
      pagination: {
        start: start ?? 0, // <- добавить
        limit: amount ?? 11
      },
      filters: activeSlug && {
        tag: {
          slug: {
            $eq: activeSlug
          }
        }
      },
      fields: ['name', 'description', 'slug', 'createdDate', 'time'],
      populate: {
        image: {
          fields: ['url', 'width', 'height', 'alternativeText']
        },
        // faculty: {
        //   fields: ['name', 'slug', 'color'],
        //   populate: {
        //     tagImage: {
        //       fields: ['url', 'width', 'height', 'alternativeText']
        //     }
        //   }
        // },
        category: {
          fields: ['name', 'slug']
        },
        tag: {
          fields: ['name', 'slug', 'color'],
          populate: {
            tagImage: {
              fields: ['url', 'width', 'height', 'alternativeText']
            }
          }
        }
      },

      locale: context.locale
    })

    const res = await fetcher<TResJournals>(
      `${PATHS.back.root.index}${PATHS.back.api.journals.index}?${query}`
    )

    return {
      data: res?.data || null,
      total: res?.meta?.pagination?.total ?? 0
    }
  } catch (e) {
    console.log('%cfetchJournals.ts line:9 e', 'color: #007acc;', e)
  }
  return null
}
